export * from './api';
export { default as colors } from '../../../common/helpers/colors';
export * from './common';
export * from './mocks';
export * from './sample-filters';

export const DEFAULT_STUDY_ID = '-';

export const MAX_GROUP_KEY_BY_DAY_DIFFERENCE = 90;

export const TARGET_GOAL_VALUE = {
  MIN: 0,
  MAX: 100000,
};

export const STUDY_YEAR_LIMITS = {
  MIN: 4,
  MAX: 50,
};
